import { TabsEnum } from 'v3/shared/enums/tabs-emun';

export const tabsAdmin = {
  title: 'Todas as abas',
  tabs: [
    {
      label: 'Admin',
      value: TabsEnum.AdminTab,
    },
    {
      label: 'Grupos',
      value: TabsEnum.GroupTab,
    },
  ],
};

export const tabsGroups = {
  title: 'Aba grupos',
  tabs: [
    {
      label: 'Grupos',
      value: TabsEnum.GroupTab,
    },
  ],
};

export const tabsStores = {
  title: 'Todas as abas',
  tabs: [
    {
      label: 'Lojas',
      value: TabsEnum.StoresTab,
    },
    {
      label: 'Vendedores',
      value: TabsEnum.SellersTab,
    },
  ],
};

export const tabsSellers = {
  title: 'Aba sellers',
  tabs: [
    {
      label: 'Ranks',
      value: TabsEnum.StoresTab,
    },
  ],
};
